import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import withCurrentMediaSource from '../../_hocs/withCurrentMediaSource';
import withSearch from '../../_hocs/withSearch';
import { MediaSourceType } from '../../types';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import searchInputStyles from './SearchInput.scss';
const enhance = compose(withCurrentMediaSource, withSearch, withMobileContext, withTranslation());
export class SearchInput extends React.Component {
    componentDidMount() {
        if (this.props.searchInput && this.inputEl) {
            this.inputEl.focus();
        }
    }
    componentDidUpdate(_, prevState) {
        if (this.state.isFocused && !prevState.isFocused) {
            this.inputEl.focus();
        }
    }
    render() {
        const { t, searchInput, currentMediaSource, isMobile } = this.props;
        const { isFocused } = this.state;
        if (currentMediaSource === MediaSourceType.STASH) {
            return null; // stash doesn't support searching
        }
        const isActive = isFocused || searchInput;
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(searchInputStyles['root'], isActive && searchInputStyles['active'], this.props.className)
        }, (!isMobile || isActive) && /*#__PURE__*/ React.createElement(TextInput, {
            ref: this.refInput,
            id: "search-input",
            label: t('mediapopup.searchForDeviations'),
            placeholder: t('mediapopup.searchForDeviations'),
            value: searchInput,
            onChange: this.onChange,
            onKeyPress: this.onKeyPress,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            postfix: /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
                onClick: this.handleSubmit
            }, /*#__PURE__*/ React.createElement(SearchIcon, {
                disableDefaultColors: true,
                size: IconSize.SMALLER
            })),
            noBottomSpacing: true,
            isLabelHidden: true
        }));
    }
    handleSearch(searchInput) {
        if (searchInput) {
            this.props.setSearchQuery(searchInput);
        } else {
            this.props.unsetSearchQuery();
        }
    }
    constructor(...args){
        super(...args);
        _define_property(this, "inputEl", void 0);
        _define_property(this, "blurTimeout", void 0);
        _define_property(this, "state", {
            isFocused: false
        });
        _define_property(this, "refInput", (input)=>this.inputEl = input);
        _define_property(this, "onChange", (e)=>{
            this.props.setSearchInput(e.target.value);
        });
        _define_property(this, "onKeyPress", (event)=>{
            if (event.key === 'Enter') {
                this.handleSubmit();
            }
        });
        _define_property(this, "handleSubmit", ()=>{
            this.handleSearch(this.inputEl.value);
        });
        _define_property(this, "onFocus", ()=>{
            this.setState({
                isFocused: true
            });
        });
        _define_property(this, "onBlur", ()=>{
            // Timeout allows us to dismiss the action if blur happened due to "clear" being clicked
            if (this.props.isMobile) {
                this.blurTimeout = window.setTimeout(()=>{
                    this.handleSearch(this.props.searchInput);
                }, 100);
            }
            this.setState({
                isFocused: false
            });
        });
        _define_property(this, "onClearClick", ()=>{
            this.blurTimeout && clearTimeout(this.blurTimeout);
            this.props.setSearchInput('');
            if (this.props.searchQuery) {
                this.props.unsetSearchQuery();
            }
        });
        _define_property(this, "onSearchClick", ()=>{
            this.setState({
                isFocused: true
            });
            this.handleSearch(this.props.searchInput);
        });
    }
}
export default enhance(SearchInput);
